import React, { ReactNode } from 'react';
import Alert from 'src/shared/components/ui/alert';

export type WarningMessageProps = { message: ReactNode };

const WarningMessage = ({ message }: WarningMessageProps) => {
    return (
        <div className='flex flex-col gap-2 w-full'>
            <Alert severity='warning'>{message}</Alert>
        </div>
    );
};

export default WarningMessage;
